import { motion } from "framer-motion";

const members = [
  {
    name: "Gérard ADADE",
    titleLine:
      "Juriste en droit des affaires - droit des entreprises en difficulté",
    image: "/equipe-gerard-adade.webp",
    alt: "Portrait de Gérard Adade, fondateur de ProSecours",
    bio:
      "Diplômé d'un Master en droit des affaires, avec une formation approfondie en droit des entreprises en difficulté. Il accompagne les entreprises en difficulté dans la préparation de leurs actes, la réunion des pièces et le suivi des dépôts auprès des greffes compétents.",
    testid: "team-member-gerard",
  },
  {
    name: "Brandon JOHNSON",
    titleLine: "Juriste en droit des affaires - droit des sociétés",
    image: "/equipe-brandon-johnson.webp",
    alt: "Portrait de Brandon Johnson, juriste ProSecours",
    bio:
      "Diplômé d'un Master en droit des affaires et de l'entreprise. Formaliste pendant plusieurs années, il a développé une solide pratique des actes, des dépôts et du suivi des formalités juridiques pour rendre les démarches plus lisibles, rapides et accessibles.",
    testid: "team-member-brandon",
  },
];

export default function Equipe() {
  return (
    <section
      id="equipe"
      data-testid="team-section"
      className="border-t border-[#1a1918]/15 bg-white py-24 md:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="mb-14 grid grid-cols-12 md:mb-20"
        >
          <div className="col-span-12 md:col-span-3">
            <span data-testid="team-kicker" className="section-badge">
              § Notre équipe
            </span>
          </div>
          <div className="col-span-12 mt-4 md:col-span-8 md:col-start-4 md:mt-0">
            <h2 className="font-serif-ed text-5xl leading-[1] tracking-tight text-[#1a1918] md:text-6xl lg:text-7xl">
              Une équipe juridique et{" "}
              <span className="italic text-[#ce1e20]">opérationnelle</span>.
            </h2>
            <p
              data-testid="team-ethics-statement"
              className="mt-8 max-w-3xl border-l-2 border-[#ce1e20] bg-[#f7f5f0] p-5 text-base leading-relaxed text-[#1a1918]/78 md:text-lg"
            >
              Notre équipe traite chaque dossier avec éthique et déontologie.
              Nous accordons une importance particulière à la qualité de la
              relation avec nos clients et veillons à ce que chaque dossier soit
              traité avec transparence et confidentialité.
            </p>
          </div>
        </motion.div>

        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-6 md:grid-cols-2 md:gap-10">
          {members.map((member, i) => (
            <motion.article
              key={member.name}
              data-testid={member.testid}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12 }}
              className="bg-[#f7f5f0] p-5 shadow-sm md:p-7"
            >
              <div className="aspect-[3/4] overflow-hidden bg-[#efece5]">
                <img
                  src={member.image}
                  alt={member.alt}
                  className="h-full w-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="pt-7 text-left">
                <h3 className="font-serif-ed text-3xl tracking-tight text-[#1a1918] md:text-4xl">
                  {member.name}
                </h3>
                <div
                  data-testid={`${member.testid}-title`}
                  className="mt-3 whitespace-nowrap text-[8px] font-semibold leading-snug text-[#ce1e20] md:text-[11px]"
                >
                  {member.titleLine}
                </div>
                <p className="mt-5 text-sm leading-relaxed text-[#1a1918]/75 md:text-base">
                  {member.bio}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
